export const PACKAGE_LIST_EXTERNAL_TABLE_HEADERS = [
    {
        displayName: "ID",
        name: "id",
        orderable: true
    },
    {
        displayName: "Name",
        name: "packageName",
        orderable: true
    },
    {
        displayName: "Implementation Type",
        name: "implementationId",
        orderable: true
    },
    {
        displayName: "Created On",
        name: "createdOn",
        orderable: true
    },
    {
        displayName: "Updated On",
        name: "lastUpdatedOn",
        orderable: true
    },
    {
        displayName: "Compliance Letter",
        name: "complianceLetter",
        orderable: false
    },
    {
        displayName: "Package Status",
        name: "packageStateDisplayName",
        orderable: false
    },
    {
        displayName: "",
        name:"",
        orderable: false
    }
]